const isCurrentRoute = (linkPath, { pathname }, exact = false) => (
  exact ? linkPath === pathname : pathname.includes(linkPath)
);

export default isCurrentRoute;
